import { Injectable } from '@angular/core'
import { Logger } from '../../../logger.service'
import { ApiService } from '../../general/api.service'
import { BehaviorSubject, Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { Restaurant } from '../../../models'
import { HttpParams } from '@angular/common/http'
import { LocalStorageService } from '@hmp/helper'

const log = new Logger('RestaurantService')

/**
 * Đây là services dành cho ExpenseService
 */
@Injectable({ providedIn: 'root' })
export class RestaurantService {
  isRestaurantChange$ = new BehaviorSubject<boolean>(false)
  isRestaurantChange = this.isRestaurantChange$.asObservable()
  constructor(
    private apiService: ApiService,
    private storage: LocalStorageService
  ) {}
  /**
   * Khai báo tất cả các path sẻ sử dụng
   */
  private _apiPath = {
    list: 'business/business_restaurants',
    detail: 'business/business_restaurants',
    print_settings: 'business/print_settings',
  }

  /**
   * Lấy tất cả Expense
   */
  getAll(params?: any): Observable<any> {
    let pa = new HttpParams().set(
      'bid',
      this.storage.getActiveLocalBusinessID()
    )
    if (params) {
      Object.keys(params).forEach(function(key) {
        pa = pa.append(key, params[key])
      })
    }

    return this.apiService.get<any>(this._apiPath.list, pa).pipe(
      map(data => {
        return data
      })
    )
  }

  /**
   * Lấy thông tin chi tiết của Expense dưạ vào @id
   * @param Id ID của Expense
   */
  getDetail(id: string): Observable<Restaurant> {
    return this.apiService
      .get<Restaurant>(`${this._apiPath.detail}/${id}`)
      .pipe(
        map(data => {
          return data
        })
      )
  }

  /**
   * Tạo Expense
   * @param res Thông tin Expense
   */
  create(res: Restaurant): Observable<any> {
    res._id = null
    return this.apiService.post(this._apiPath.detail, res).pipe(
      map(data => {
        log.debug(data)
        this.isRestaurantChange$.next(true)
        return
      })
    )
  }

  /**
   * Chỉnh sửa thông tin Expense
   *
   * @param res Thông tin Expense muốn chỉnh sửa
   */
  edit(id: string, res: Restaurant): Observable<any> {
    return this.apiService.put(`${this._apiPath.detail}/${id}`, res).pipe(
      map(data => {
        this.isRestaurantChange$.next(true)
        return data
      })
    )
  }

  /**
   * Xóa thông tin Expense
   *
   * @param id Xóa Expense bằng Expense ID
   */
  delete(id): Observable<any> {
    return this.apiService.delete(`${this._apiPath.detail}/${id}`).pipe(
      map(data => {
        log.debug(data)
        this.isRestaurantChange$.next(true)
        return data
      })
    )
  }

  getPOSPrintSettings(params?: any): Observable<any> {
    let pa = new HttpParams()
    if (params) {
      Object.keys(params).forEach(function(key) {
        pa = pa.append(key, params[key])
      })
    }
    let bid = this.storage.getActiveLocalBusinessID()
    return this.apiService
      .get(`${this._apiPath.print_settings}/${bid}`, pa)
      .pipe(
        map(data => {
          // log.debug(data)
          return data
        })
      )
  }

  updatePrintSettings(res): Observable<any> {
    return this.apiService.post(`${this._apiPath.print_settings}`, res).pipe(
      map(data => {
        log.debug(data)
        return data
      })
    )
  }
}
